const FETCH_TIMEOUT_MS = 5_000;

function getSessionData() {
  const el = document.getElementById("session-data");
  return el ? JSON.parse(el.textContent) : null;
}

/**
 * Fetch WebLive /config and store the result in window.tmgConfig.
 * Always resolves: failures are logged and window.tmgConfig is set with
 * at least { gatewayUrl, brand } so token exchange can still proceed.
 */
export async function initTmgConfig() {
  const session = getSessionData();
  if (!session?.gatewayUrl) return;

  const base = { gatewayUrl: session.gatewayUrl, brand: session.brand };

  try {
    const res = await fetch(`${session.gatewayUrl}/config`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-User-Agent": `${session.brand}/10.9 ( network=${session.brand}; ) web/12.1.0 ( web; )`,
        "Accept-Language": "en-US",
      },
      signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
    });

    if (!res.ok) throw new Error(`/config responded ${res.status}`);
    const config = await res.json();
    window.tmgConfig = { ...config, ...base };
  } catch (err) {
    console.warn("[tmg-config] Failed to load config:", err?.message ?? err);
    window.tmgConfig = base;
  }
}

export function getTmgConfig() {
  return window.tmgConfig ?? null;
}

export function getCreditsUrl() {
  return window.tmgConfig?.economy?.purchase?.url ?? null;
}
